module.exports = __webpack_public_path__ + "static/logo-en-8ce16ba0db94bd25d548e258474b3ee9.png";